
import React, { useState, useEffect } from 'react';
import MaxLoanList from './MaxLoanList';
import losData from '../hybriddata/loanstatusdata.json'
import { SingleFormLabel, SingleFormLabelBold } from '../validation/Form-Components';

const AAPFreeholdProperty = (props) => {

    const {response,propertyData} = props;

    const [freeholdInfo, setFreeholdInfo] = useState([]);
    const [maxLoanNoPropList,setMaxLoanNoPropList] = useState([]);

    useEffect(() => {
        console.log('@FreeholdProperty useEffect');
        if(response.maxCIPAIPLoanAmtFreehold && response.maxCIPAIPLoanAmtFreehold !==null 
            && response.maxCIPAIPLoanTenureFreehold && response.maxCIPAIPLoanTenureFreehold !== null) {
            let temp=[];
            const formatObj = {
                loanTenure: response.maxCIPAIPLoanTenureFreehold,
                loanAmount: response.maxCIPAIPLoanAmtFreehold
            }

            temp.push(formatObj);
            setFreeholdInfo(temp);
        }
        setMaxLoanNoPropList(response.maxLoanDetailsNoProp);
    }, []);
   
    return(
        <div>
            <div className='pad-top10'>
                <SingleFormLabelBold labelId={'lblAIPtxt1'} labelName={losData.freehold.txt1} />
                <div className="row around-xs inputPair elementVisible">
                    <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                        <span>{losData.leasehold.txt1_desc}</span>
                        <span className='txt-grey-fs16'>{propertyData.PropertyAddress}</span>
                    </div>
                </div>
            </div>

            <MaxLoanList data={freeholdInfo} />

            {maxLoanNoPropList &&
            <div>
                <div className='pad-top20'>
                    <SingleFormLabelBold labelId={'lblAIPtxt2'} labelName={losData.freehold.txt2} />
                </div>
                <MaxLoanList data={maxLoanNoPropList} />
            </div>
            }

            <div className='pad-top10'>
                <SingleFormLabel labelId={'lblAIPtxt3'} labelName={losData.freehold.txt3} />
            </div>
        </div>
    )
}

export default AAPFreeholdProperty;